define('views/modules/setting/business/payment/payment-current-plan',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils',
    // services
    'services/i18n',
    'services/user',
    // views
    'views/parts/info-section',
    'views/parts/form/button',
    // templates
    'text!templates/modules/setting/business/payment/payment-current-plan.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, Bootbox, U,
    // services
    i18n,
    User,
    // views
    VInfoSection,
    VButton,
    // templates
    TPaymentCurrentPlan
) {

    var VPaymentCurrentPlan = Backbone.Epoxy.View.extend({
        template: TPaymentCurrentPlan,

        regions: {
            currentPlanButton: '.payment-current-plan-button-section',
        },

        initialize: function(opt) {
            this.options = opt = opt || {};

            this.view = {
                info: new VInfoSection({
                    hideTitleSection: true,
                }),
            };

            if (!this.options.standalone) {
                this.view = _.extend({
                    currentPlanButton: new VButton({
                        label: "payment:switch_plan",
                        callback: this.onChangePlan,
                        context: this,
                        icon: "sl-icon-refresh",
                    }),
                }, this.view);
            }
        },

        render: function(hiddenDelay) {
            var langISOCode = User.get('languageCode'),
                teamPaymentModel = this.options.teamPaymentModel,
                teamPaymentCurrency = teamPaymentModel.getCurrency();

            var currencyFormatter = new Intl.NumberFormat(langISOCode, {
                style: 'currency',
                currency: teamPaymentCurrency,
                minimumFractionDigits: 2
            });

            var percentageFormatter = new Intl.NumberFormat(langISOCode, {
                style: 'percent',
                maximumFractionDigits: 3
            });

            var currentPlan = this.options.currentPlan,
                membershipPrice = currentPlan.getCurrencies()[teamPaymentCurrency].price,
                taxAmount = membershipPrice * teamPaymentModel.getTaxRate(),
                totalAmount = membershipPrice + taxAmount,
                view = this.view,
                html = Mustache.render(this.template, Mustache.getContext({
                    payment_plan_id: currentPlan.getName(),
                    allowedClients: currentPlan.getMaxMembers(),
                    allowedCoaches: currentPlan.getMaxCoaches(),
                    payment_monthly_fees: currencyFormatter.format(currentPlan.getCurrencies()[teamPaymentCurrency].price),
                    taxesPercentage: percentageFormatter.format(teamPaymentModel.getTaxRate()),
                    payment_taxes: currencyFormatter.format(taxAmount),
                    payment_total: currencyFormatter.format(totalAmount)
                }));

            this.assign(view.info, this.$el)
                .applyBindings();

            view.info.setContent(html);

            this.generateZones();

            if (!this.options.standalone) {
                this.assign(view.currentPlanButton, this.zone.$currentPlanButton);
            }

            return this;
        },

        updateOptions: function(options) {
            this.options = options;

            if (this.options.pendingPlanModel) {
                this.options.currentPlan = this.options.pendingPlanModel;
            } else {
                this.options.currentPlan = options.currentPlanModel;
            }

            this.options.teamPaymentModel = options.teamPaymentModel;

        },

        ////////////
        // events //
        ////////////
        onChangePlan: function(confirmed) {
            this.trigger("click:changePlan");
        },

    });

    return VPaymentCurrentPlan;
});

